import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSelect from "../../../components/MaterialSelect";

import {
  deleteData,
  fetchData,
  fetchDataById,
  postData,
  putData,
} from "../../Utils/Baseurl";
import Swal from "sweetalert2";
import SimpleTable from "../../../components/SimpleTable";
import { useSnackbar } from "../../../components/SnackbarProvider";
import { useLoading } from "../../../context/loadingcontext";
import CanAccess from "../../../components/permission/CanAccess";
import { useAuth } from "../../../context/AuthContext";

const DesignationMaster = () => {
  const { rolePermission } = useAuth();
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState([]);
  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [designationData, setDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "unchecked",
    designationNameStatus: "unchecked",
  });

  useEffect(() => {
    getDepartmentList();
    getDesignationList();
  }, []);

  //Get Department
  const getDepartmentList = async () => {
    try {
      const response = await fetchData("api/department/");

      if (response?.status && Array.isArray(response.data)) {
        setDepartment(response.data);
      } else {
        setDepartment([]);
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);

      setDepartment([]);
    }
  };

  //   Get Designation List

  const getDesignationList = async () => {
    setIsLoading(true);
    try {
      const response = await fetchData("api/designation/");

      if (response?.status && Array.isArray(response.data)) {
        setList(response.data);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);
      setList([]);
    } finally {
      setIsLoading(false);
    }
  };

  //   Create or Update Designation
  const createDesignation = async () => {
    setCirleLoading(true);
    const data = {
      department_id: designationData?.departmentName?.value,
      designation: designationData?.designationName,
    };
    try {
      let response;
      if (pages.edit) {
        response = await putData(`api/designation/${pages?.id}/`, data);
      } else {
        response = await postData("api/designation/", data);
      }
      if (response.status) {
        showSnackbar(response?.message, "success");
        handleDialogClose();
        getDesignationList();
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }
      showSnackbar(message, "error");
      handleDialogClose();
    } finally {
      setCirleLoading(false);
    }
  };

  const viewDesignation = async (row) => {
    handleDialogOpen();
    setCirleLoading(true);
    setPages({
      view: true,
      edit: false,
    });

    try {
      const response = await fetchDataById(`api/designation/${row}/`);
      if (response.status) {
        setDesignationData((prev) => ({
          ...prev,
          departmentName: {
            value: response?.data?.department?.id,
            label: response?.data?.department?.department_name,
          },
          designationName: response?.data?.designation,
        }));
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const deleteDesignation = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this designation?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setCirleLoading(true);
      try {
        const response = await deleteData(`api/designation/${row}/`);
        if (response.status) {
          showSnackbar(response?.message, "success");
          getDesignationList();
        } else {
          showSnackbar(response?.message, "error");
        }
      } catch (error) {
        let message = "An unexpected error occurred";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.message) {
          message = error.message;
        }
        showSnackbar(message, "error");
      } finally {
        setCirleLoading(false);
      }
    }
  };

  //Edit Function call
  const editDesignation = async (row) => {
    handleDialogOpen();
    setCirleLoading(true);
    setPages({
      view: false,
      edit: true,
      id: row,
    });
    try {
      const response = await fetchDataById(`api/designation/${row}/`);

      if (response.status) {
        setDesignationData((prev) => ({
          ...prev,
          departmentName: {
            value: response?.data?.department?.id,
            label: response?.data?.department?.department_name,
          },
          designationName: response?.data?.designation,
          departmentNameStatus: "success",
          designationNameStatus: "success",
        }));
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setCirleLoading(false);
    }
  };
  //   Handle Input Change
  const handleDesignationDatachange = (event, selectEvent) => {
    let designationState = { ...designationData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "departmentName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          designationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          designationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      designationState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "designationName":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              designationState[event.target.name + "Status"] = "success";
            } else {
              designationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        designationState[event.target.name] = event.target.value;
      }
    }
    setDesignationData(designationState);
  };

  //   Dialog Control Handlers
  const handleDialogOpen = () => setDialogOpen(true);

  const handleDialogClose = () => {
    setDialogOpen(false);
    setPages({});
    setDesignationData({});
  };
  //   Table Column & Row Configuration
  const designationTable = {
    columns: [
      {
        key: "Designation",
        header: "Designation Name",
      },
      {
        key: "Department",
        header: "Department Name",
      },
      { header: "ACTION", key: "action" },
    ],
    row: list?.map((item) => ({
      id: item?.id,
      Designation: item?.designation.replace(/_/g, " "),
      Department: item?.department?.department_name.replace(/_/g, " "),
    })),
  };
  const disabledFunction = () => {
    let disabled;
    if (
      designationData?.departmentNameStatus == "success" &&
      designationData?.designationNameStatus == "success"
    ) {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };
  // role permission for table
  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Designation Master", "Designation Edit"),
    showView: CanAccess.can(rolePermission, "Designation Master", "Designation View"),
    showDelete: CanAccess.can(
      rolePermission,
      "Designation Master",
      "Designation Delete"
    ),
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Designation Master
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the Designation list here.
          </MaterialTypography>
        </Stack>
        {/* <CanAccess module="Designation Master" component="Designation Add"> */}
          <MaterialButton
            variant="gradient"
            color="dark"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleDialogOpen}
          >
            Add Designation
          </MaterialButton>
        {/* </CanAccess> */}
      </Stack>
      <SimpleTable
        columns={designationTable?.columns}
        data={designationTable?.row}
        onEdit={editDesignation}
        onDelete={deleteDesignation}
        onView={viewDesignation}
        isLoading={isLoading}
        actionVisibility={actionVisibility}
      />

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="new-employee-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            width: "600px",
            maxWidth: "90%",
            minHeight: "50%",
          },
        }}
      >
        <DialogTitle id="new-employee-dialog-title">
          {pages?.view
            ? "View Designation"
            : pages?.edit
            ? "Edit Designation"
            : "Add Designation"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Department <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="departmentName"
                  value={designationData.departmentName}
                  onChange={handleDesignationDatachange}
                  options={department.map((value) => {
                    return {
                      value: value.id,
                      label: value.department_name,
                    };
                  })}
                  error={designationData.departmentNameStatus === "error"}
                  success={designationData.departmentNameStatus === "success"}
                  isDisabled={pages.view}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Designation Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="designationName"
                  placeholder="Designation Name"
                  value={designationData.designationName}
                  onChange={handleDesignationDatachange}
                  error={designationData.designationNameStatus === "error"}
                  success={designationData.designationNameStatus === "success"}
                  disabled={pages.view}
                />
                {designationData.designationNameStatus === "error" && (
                  <FormControl error style={{ marginTop: "0px" }}>
                    <FormHelperText>
                      Department code should be alphanumeric.
                    </FormHelperText>
                  </FormControl>
                )}
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleDialogClose} color="primary">
            Cancel
          </MaterialButton>
          {!pages.view && (
            <MaterialButton
              disabled={disabledFunction()}
              onClick={createDesignation}
              color="dark"
              variant="contained"
            >
              Save
            </MaterialButton>
          )}
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default DesignationMaster;
